import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { NEWSLETTER_COPY } from './newsletter.copy';

/**
 * Microcopy de consentimiento (B8; spec docs/specs/newsletter-web-plan.md, W4) con
 * el enlace a la Política de Privacidad. Lo pintan `NewsletterFormComponent` (bajo
 * el botón) y el registro (junto a la casilla).
 *
 * `external`: el enlace abre `/privacidad` en otra pestaña con un `href` plano. Lo
 * usa el registro, que vive en un modal que no se cierra al navegar (N6): con
 * `routerLink` la política se abriría por detrás y el formulario se perdería.
 *
 * El color sale de `--newsletter-consent-color` / `--newsletter-consent-link-color`
 * para que cada variante del formulario (p. ej. el footer oscuro) mantenga AA.
 */
@Component({
  selector: 'app-newsletter-consent',
  imports: [RouterLink],
  // En una línea: el texto que rodea al enlace no debe ganar ni perder espacios.
  template: `<p class="newsletter-consent">{{ copy.CONSENT_BEFORE }}@if (external()) {<a class="newsletter-consent__link" [href]="copy.CONSENT_HREF" target="_blank" rel="noopener">{{ copy.CONSENT_LINK }}</a>} @else {<a class="newsletter-consent__link" [routerLink]="copy.CONSENT_HREF">{{ copy.CONSENT_LINK }}</a>}{{ copy.CONSENT_AFTER }}</p>`,
  styles: `
    :host {
      display: block;
    }
    .newsletter-consent {
      margin: 0;
      font-family: var(--font-family-body);
      font-size: var(--text-size-xs);
      line-height: var(--leading-normal);
      color: var(--newsletter-consent-color, var(--color-text-secondary));
    }
    .newsletter-consent__link {
      color: var(--newsletter-consent-link-color, var(--color-text-link));
      text-decoration: underline;
      text-underline-offset: 2px;
    }
    .newsletter-consent__link:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 2px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterConsentComponent {
  readonly external = input(false);

  protected readonly copy = NEWSLETTER_COPY;
}
